import {useContext} from 'react'

import {BLOCKS, INLINES} from '@contentful/rich-text-types'

import Context from '@s-ui/react-context'

import {BASE_CLASS, PARAGRAPH_CLASS} from '../settings.js'

const ArticleParagraph = (_, children) => {
  return <p className={PARAGRAPH_CLASS}>{children}</p>
}

const ArticleLink = (_, children) => {
  const LINK_CLASS = `${BASE_CLASS}-content--link`
  const {domain} = useContext(Context)
  const domainConfig = domain.get('config')
  const {NEWS_HOME_PATH_PATTERN} = domainConfig.get('page')

  return (
    <a className={LINK_CLASS} href={_.data?.uri || NEWS_HOME_PATH_PATTERN} target="_blank">
      {children}
    </a>
  )
}

export const documentContentfulOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: ArticleParagraph,
    [INLINES.HYPERLINK]: ArticleLink
  }
}
